import request from './index'

// 示例接口
export default {
  // GET 示例
  getBannerList(params) {
    return request({
      url: '/banner/list',
      method: 'get',
      params
    })
  },
  getCaseList(params) {
    return request({
      url: '/case/list',
      method: 'get',
      params
    })
  },
  getNewsList(params) {
    return request({
      url: '/news/list',
      method: 'get',
      params
    })
  },
  // POST 示例
  postData(data) {
    return request({
      url: '/api/postData',
      method: 'post',
      data
    })
  },

  // 其他请求方式同理...
  
  // 带动态URL的请求
  getUserById(id) {
    return request({
      url: `/api/user/${id}`,
      method: 'get'
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/api.js